/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeDrawLogsChallengeOption } from './ChallengeDrawLogsChallengeOption';
import {
    ChallengeDrawLogsChallengeOptionFromJSON,
    ChallengeDrawLogsChallengeOptionFromJSONTyped,
    ChallengeDrawLogsChallengeOptionToJSON,
    ChallengeDrawLogsChallengeOptionToJSONTyped,
} from './ChallengeDrawLogsChallengeOption';
import type { ChallengeDrawLog } from './ChallengeDrawLog';
import {
    ChallengeDrawLogFromJSON,
    ChallengeDrawLogFromJSONTyped,
    ChallengeDrawLogToJSON,
    ChallengeDrawLogToJSONTyped,
} from './ChallengeDrawLog';

/**
 * 
 * @export
 * @interface GetDrawLogsResponse
 */
export interface GetDrawLogsResponse {
    /**
     * 
     * @type {Array<ChallengeDrawLog>}
     * @memberof GetDrawLogsResponse
     */
    logs?: Array<ChallengeDrawLog>;
    /**
     * Total number of draw logs
     * @type {number}
     * @memberof GetDrawLogsResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ChallengeDrawLogsChallengeOption>}
     * @memberof GetDrawLogsResponse
     */
    challenges?: Array<ChallengeDrawLogsChallengeOption>;
}

/**
 * Check if a given object implements the GetDrawLogsResponse interface.
 */
export function instanceOfGetDrawLogsResponse(value: object): value is GetDrawLogsResponse {
    return true;
}

export function GetDrawLogsResponseFromJSON(json: any): GetDrawLogsResponse {
    return GetDrawLogsResponseFromJSONTyped(json, false);
}

export function GetDrawLogsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDrawLogsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'logs': json['logs'] == null ? undefined : ((json['logs'] as Array<any>).map(ChallengeDrawLogFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'challenges': json['challenges'] == null ? undefined : ((json['challenges'] as Array<any>).map(ChallengeDrawLogsChallengeOptionFromJSON)),
    };
}

export function GetDrawLogsResponseToJSON(json: any): GetDrawLogsResponse {
    return GetDrawLogsResponseToJSONTyped(json, false);
}

export function GetDrawLogsResponseToJSONTyped(value?: GetDrawLogsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logs': value['logs'] == null ? undefined : ((value['logs'] as Array<any>).map(ChallengeDrawLogToJSON)),
        'total': value['total'],
        'challenges': value['challenges'] == null ? undefined : ((value['challenges'] as Array<any>).map(ChallengeDrawLogsChallengeOptionToJSON)),
    };
}

